import React, { Component } from 'react'
import Spinner from 'react-spinkit'
import { PaperScope } from 'paper/dist/paper-core'
import { load } from 'opentype.js/dist/opentype.js'
import * as layoutProcedures from '../layoutProcedures'
import xml2js from 'xml2js'

let SIZE = 400

class LogoCanvas extends Component {
  constructor(props) {
    super(props)
    this.paper = new PaperScope()
    this.state = {
      editedParams: null,
      lastProps: null,
      loading: true
    }
  }

  renderLogo(editing) {
    let { uid, logoParams } = this.props
    let editedParams = this.props.editedParams[uid]
    if (window.innerWidth <= 600) SIZE = 300

    if (editedParams) {
      Object.assign(logoParams, editedParams)
    }

    let {
      logoName,
      brandTypeface,
      layoutProcedureName,
      layoutProcedureParams,
      colorPalette,
      brandSlogan,
      sloganTypeface,
      asset
    } = logoParams

    if (!colorPalette) return

    load(brandTypeface.urls.regular, (err, font) => {
      if (err) return
      load(sloganTypeface.urls.regular, (err, secondFont) => {
        if (err) return

        if (!logoName) logoName = "My Brand"
        if (layoutProcedureParams.capitalizeBrand && logoName) logoName = logoName.toUpperCase()
        if (layoutProcedureParams.capitalizeSlogan && brandSlogan) brandSlogan = brandSlogan.toUpperCase()

        let colorPaletteSelected = colorPalette.light
        if (colorPalette.colorBackground) {
          colorPaletteSelected = colorPalette.colored
        }
        let parameters = {
          parameters: layoutProcedureParams,
          slogan: brandSlogan,
          secondTypeface: secondFont,
          logoName: logoName,
          colorPalette: colorPaletteSelected,
          typeface: font,
          width: SIZE,
          height: SIZE,
        }

        if (!asset) {
          // Setup canvas
          let canvas = this.refs.logoCanvas
          if (!canvas) return
          let context = canvas.getContext('2d')
          if (!context) return
          canvas.width = SIZE
          canvas.height = SIZE
          context.setTransform(1, 0, 0, 1, 0, 0)
          let paper = this.paper
          paper.setup(canvas)
          paper.project.clear()

          // Light
          parameters.paper = paper
          layoutProcedures[layoutProcedureName](parameters)
          let rawSVG = paper.project.exportSVG({asString: true})

          // Dark
          let canvasDark = this.refs.logoCanvasDark
          if (!canvasDark) return
          let contextDark = canvasDark.getContext('2d')
          if (!contextDark) return
          canvasDark.width = SIZE
          canvasDark.height = SIZE

          // Setup canvas
          contextDark.setTransform(1, 0, 0, 1, 0, 0)
          paper.setup(canvasDark)
          parameters.colorPalette = colorPalette.dark
          layoutProcedures[layoutProcedureName](parameters)

          if (this.state.loading && !editing)
            this.setState({ loading: false })
          if (this.props.availableLogoPreviews.payload[uid].svg !== rawSVG) {
            let rawSVGDark = paper.project.exportSVG({asString: true})
            return this.props.updateLogoCanvas({
              rawSVG: rawSVG,
              rawSVGDark: rawSVGDark,
              id: this.props.uid,
              canvas: this.refs.logoCanvas,
              canvasDark: this.refs.logoCanvasDark,
              logoParams
            })
          }
        }
        else { // Load symbol if needed
          return fetch(asset.icon_url)
          .then(response => { return response.text() })
          .then(text => {
            let tagNameProcessors = (name) => {
              if (name === "switch") return "g"
              return name
            }
            let attrValueProcessors = (value, name) => {
              if (name === "transform") {
                let replaced = value.replace(/-/g, ' -')
                return replaced
              }
              return value
            }
            return xml2js.parseString(text, {
                tagNameProcessors: [tagNameProcessors],
                attrValueProcessors: [attrValueProcessors]
              },
              (err, result) => {
                let builder = new xml2js.Builder()
                let xml = builder.buildObject(result)

                // Setup canvas
                let canvas = this.refs.logoCanvas
                if (!canvas) return
                let context = canvas.getContext('2d')
                if (!context) return
                canvas.width = SIZE
                canvas.height = SIZE
                context.setTransform(1, 0, 0, 1, 0, 0)
                let paper = this.paper
                paper.setup(canvas)
                paper.project.clear()

                return paper.project.importSVG(xml, {
                  onLoad: (symbol) => {
                    let symbolSVG = paper.project.exportSVG({asString: true})
                    parameters.asset = symbol
                    parameters.paper = paper
                    layoutProcedures[layoutProcedureName](parameters)
                    let rawSVG = paper.project.exportSVG({asString: true})
                    // let urlSVG = "data:image/svg+xmlutf8," + encodeURIComponent(rawSVG)

                    return paper.project.importSVG(xml, {
                      onLoad: (symbol) => {
                        // Dark
                        let canvasDark = this.refs.logoCanvasDark
                        if (!canvasDark) return
                        let contextDark = canvasDark.getContext('2d')
                        if (!contextDark) return
                        canvasDark.width = SIZE
                        canvasDark.height = SIZE

                        contextDark.setTransform(1, 0, 0, 1, 0, 0)
                        paper.setup(canvasDark)
                        parameters.colorPalette = colorPalette.dark
                        parameters.asset = symbol
                        parameters.paper = paper
                        layoutProcedures[layoutProcedureName](parameters)

                        if (this.state.loading && !editing)
                          this.setState({ loading: false })
                        if (this.props.availableLogoPreviews.payload[uid].svg !== rawSVG) {
                          let rawSVGDark = paper.project.exportSVG({asString: true})
                          let asset = logoParams.asset
                          asset.svg = symbolSVG
                          logoParams.asset = asset
                          return this.props.updateLogoCanvas({
                            rawSVG: rawSVG,
                            rawSVGDark: rawSVGDark,
                            id: this.props.uid,
                            canvas: this.refs.logoCanvas,
                            canvasDark: this.refs.logoCanvasDark,
                            logoParams
                          })
                        }
                      },
                      onError: (error) => {
                        paper.project.clear()
                      }
                    })
                  },
                  onError: (error) => {
                    paper.project.clear()
                  }
                })
              }
            )
          })
          .catch(error => {
            // Setup canvas
            let canvas = this.refs.logoCanvas
            if (!canvas) return
            let context = canvas.getContext('2d')
            if (!context) return
            canvas.width = SIZE
            canvas.height = SIZE
            context.setTransform(1, 0, 0, 1, 0, 0)
            let paper = this.paper
            paper.setup(canvas)
            paper.project.clear()

            // Light
            parameters.paper = paper
            layoutProcedures[layoutProcedureName](parameters)
            let rawSVG = paper.project.exportSVG({asString: true})

            // Dark
            let canvasDark = this.refs.logoCanvasDark
            if (!canvasDark) return
            let contextDark = canvasDark.getContext('2d')
            if (!contextDark) return
            canvasDark.width = SIZE
            canvasDark.height = SIZE

            // Setup canvas
            contextDark.setTransform(1, 0, 0, 1, 0, 0)
            paper.setup(canvasDark)
            parameters.colorPalette = colorPalette.dark
            layoutProcedures[layoutProcedureName](parameters)

            if (this.state.loading && !editing)
              this.setState({ loading: false })
            if (this.props.availableLogoPreviews.payload[uid].svg !== rawSVG) {
              let rawSVGDark = paper.project.exportSVG({asString: true})
              return this.props.updateLogoCanvas({
                rawSVG: rawSVG,
                rawSVGDark: rawSVGDark,
                id: this.props.uid,
                canvas: this.refs.logoCanvas,
                canvasDark: this.refs.logoCanvasDark,
                logoParams
              })
            }
          })
        }
      })
    })
  }

  componentDidUpdate() {
    let { uid } = this.props
    let propsEditedParams = this.props.editedParams[uid]
    if (propsEditedParams)
      if (propsEditedParams !== this.state.editedParams)
        this.renderLogo(true)
  }

  componentDidMount() {
    this.setState({ loading: true }, this.renderLogo)
  }

  avoidContextMenu(e) {
    e.preventDefault()
    return false
  }

  render() {
    let { uid } = this.props
    let id = `logo-canvas${uid}`
    let darkId = `${id}-dark`
    let backgroundColor = "#fff"
    if (this.props.logoParams) {
      if (this.props.logoParams.colorPalette) {
        if (this.props.logoParams.colorPalette.colorBackground) {
          backgroundColor = this.props.logoParams.colorPalette.colorBackground
        }
      }
    }

    return (
      <div className="logo-preview-wrapper">
        { this.state.loading ?
          <div className="logo-loading">
            <Spinner name='ball-grid-pulse' color="#666" fadeIn="none" />
          </div> : null }
        <canvas style={ { backgroundColor: `${backgroundColor}` } } ref="logoCanvas" className="logo-canvas" id={ id } onContextMenu={ this.avoidContextMenu.bind(this) }></canvas>
        <canvas style={ { display: "none" } } ref="logoCanvasDark" className="logo-canvas" id={ darkId }></canvas>
        <div className="logo-preview-watermark"></div>
      </div>
    )
  }
}

export default LogoCanvas



// WEBPACK FOOTER //
// ./src/components/LogoCanvas.js